import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs } from 'react-bootstrap';
import { Box, Button, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import { actions } from '../redux/sourceActions';
import SourceShow from '../components/SourceShow/SourceShow';
import SourceAudit from '../components/SourceAudit/SourceAudit';

const SourceShowContainer = ({ getSource, params, source }) => {
  const [activeTab, setActiveTab] = useState(1);
  const { id } = params;

  useEffect(
    () => {
      getSource(id, ['broker', 'organisation', 'channel', 'source_type']);
    },
    [id, getSource],
  );

  const handleTab = (key) => {
    setActiveTab(key);
  };

  const resource = source.resources?.[id];
  const buttons = (
    <Button bsStyle="default" label="Back" isBackButton={true} leftIcon="caret-left" />
  );

  if (!resource) {
    return (
      <InternalContainer title={'Sources'} buttons={buttons}>
        <Loader />
      </InternalContainer>
    );
  }
  return (
    <InternalContainer title={'Sources'} buttons={buttons}>
      <Tabs
        activeKey={activeTab}
        id="source-tabs"
        unmountOnExit={true}
        onSelect={handleTab}
      >
        <Tab eventKey={1} title="Details">
          <Box>
            <SourceShow resource={resource} />
          </Box>
        </Tab>
        <Tab eventKey={2} title="Audit">
          <SourceAudit
            resourceId={resource.data.id}
            sourceLabel={resource?.data?.attributes?.name}
          />
        </Tab>
      </Tabs>
    </InternalContainer>
  );
};

export default connect(
  (state) => ({
    source: state.source,
  }),
  {
    getSource: actions.getSource,
  },
)(SourceShowContainer);
